import React from "react";
import { Button } from "../button/Button";
import { colors } from "../colors/color";
import { Flex } from "../compositeComponents/FlexHelpers";
import { iconName, Icon } from "../icons/Icons";
import { Small } from "../typography/Body";
import styled from "styled-components";
import { LinkButton } from "../button/LinkButton";
import { ButtonDiv } from "../ButtonDiv";

type ListItemProps = {
    leadingIcon:iconName,
    leadingIconColor?: string,
    leadingIconBorder?: boolean,
    primaryContent:React.ReactNode,
    secondary?:{
        leadingIcon?:iconName,
        content:React.ReactNode
    },
    buttons?:
        (
            {type:'button',icon:iconName, destructive?: boolean, onClick:()=>void} |
            {type:'download', fileName:string, href:string}
        )[],
    padding?: string,
    border?: boolean
};
export function ListItem(props: ListItemProps):JSX.Element
{
    return (
        <ListItemContainer border={props.border} padding={props.padding}>
            
            <LeadingIconContainer border={props.leadingIconBorder}>
                <Icon name={props.leadingIcon} color={props.leadingIconColor || colors.icon.default} />
            </LeadingIconContainer>

            <Flex flexDirection="column" grow="1">
                <span style={{fontSize:'14px'}}>{props.primaryContent}</span>
                
                {props.secondary &&
                    <div style={{display: "flex", alignItems: "center", gap: "8px"}}>
                        {props.secondary.leadingIcon &&
                            <Icon name={props.secondary.leadingIcon} size="x-small" />
                        }
                        <Small style={{ fontSize:'12px'}}>{props.secondary.content}</Small>
                    </div>
                }
            </Flex>
            
            {props.buttons && props.buttons.length > 0 &&
                <div style={{display: 'flex', gap:'4px', flexGrow:0, alignItems: 'center'}}>
                    {props.buttons.map((p, i) =>
                        <React.Fragment key={i}>
                            {p.type === 'button' &&
                            <Button
                                variant={p.destructive ? 'destructive-text' : "text"}
                                icon={p.icon}
                                size="32px"
                                onClick={p.onClick}
                            />
                            }
                            {p.type === 'download' &&
                                <LinkButton
                                    variant="text"
                                    icon='interface_actions_download'
                                    size="32px"
                                    href={p.href}
                                    download={p.fileName}
                                />
                            }
                        </React.Fragment>   
                    )}
                </div>
            }
        </ListItemContainer>
    );
}

type ButtonListItemProps = Omit<ListItemProps, 'buttons'> & {
    onClick?: () => void
};
export function ButtonListItem(props: ButtonListItemProps): JSX.Element
{
    return (
        <ButtonDiv onClick={props.onClick}>
            <ListItem {...props} />
        </ButtonDiv>
    );
}

const ListItemContainer = styled.div<{padding?: string, border?: boolean}>`
    display:flex;
    gap:16px; 
    align-items: center; 
    width:100%;
    padding: ${props => props.padding || '2px'};
    border: ${props => props.border 
        ? `1px solid ${colors.card.outlined.default.border}`
        : 'none'
    };
    border-radius: 4px;
`;

const LeadingIconContainer = styled.div<{border?: boolean}>`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    padding: 4px;
    border: ${props => props.border 
        ? `1px solid ${colors.card.outlined.default.border}`
        : 'none'
    };
    border-radius: 4px;
`;